import { S as SearchPriceSpecial } from './index2.js';
import { t as translateDate } from './translate-date.js';

/**
   * **Neobookings**
   */
const factory = function factory({ window, document, thn }) {
    let refreshPrice;
    return {
        async languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                let aux;
                // Acevi Hotels
                if (thn.data.accountUserId === 1034361) {
                    aux = thn.parseUrlParameter('idioma')?.substring(0, 2).toLowerCase();
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                        return;
                    }
                    aux = document.querySelector('meta[http-equiv="content-language"]');
                    aux = aux && aux.getAttribute('content');
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                        return;
                    }
                    aux = document.querySelector('body');
                    aux = aux && aux.className;
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                        return;
                    }
                }
                // Cala Llenya Resort Ibiza
                if (thn.data.propertyId === 1027388) {
                    aux = (document.querySelector('.language-container > .language') || {}).textContent;
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                        return;
                    }
                }
                reject(new Error('no_language'));
            });
        },
        onStateChange: thn.debounce(() => {
            thn.pageCheck();
        }, 800),
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            // Case 1: https://bookings.azulinehotels.com/en/step-1?id=TpNi2tzFlvFc0qCOZLfqhw&arrival=2018-03-16&departure=2018-03-17&adults=2
            // Case 2: https://bookings.oneibizasuites.com/en/?id=WlBuOObsgeKjkWMSgD4eqQ&arrival=21%2F12%2F2018&departure=22%2F12%2F2018&promo=
            if (url.searchParams.has('id') && url.host.indexOf('bookings.') === 0 && url.pathname.match(/^(\/\w{2})?(\/step-1)?\/?$/i)) {
                // prepare URL for params substitution
                url.searchParams.set('arrival', '[date_begin]');
                url.searchParams.set('departure', '[date_end]');
                // export into ctx.new_url
                ctx.newUrl = url.toString();
                // then format of dates: yyyy/mm/dd -> yyyy-mm-dd
                ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
                ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
            }
            else {
                // This is not a valid BE URL
                ctx.newUrl = '';
            }
            return ctx;
        },
        getPromocode(ctx) {
            if (!thn.empty(document.querySelector('#coupon-code-msg.error')?.textContent)) {
                ctx.promocode = '';
            }
            return ctx.promocode;
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('.content.rooms');
            if (container) {
                refreshPrice = thn.debounce(() => {
                    const loading = document.body.classList.contains('loading');
                    if (!loading) {
                        ctx.widget.refresh().catch(() => { });
                    }
                }, 800);
                thn.observeDom(container, refreshPrice, {
                    childList: true,
                    subtree: true,
                    characterData: false,
                    attributes: true,
                    attributeFilter: ['class', 'style'],
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(container, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
            const containerPrice = document.querySelector('main');
            if (containerPrice) {
                const debouncedRefresh = thn.debounce(() => ctx.widget.refresh(), 600);
                const refreshPriceMutation = (mutations) => {
                    const priceUpdate = mutations.filter((mutation) => mutation.target && mutation.target instanceof Element && (mutation.target.className?.match(/tw-container tw-mx-auto/)));
                    if (!thn.empty(priceUpdate)) {
                        return debouncedRefresh();
                    }
                };
                thn.observeDom(containerPrice, refreshPriceMutation, {
                    subtree: true,
                    childList: true,
                    characterData: true,
                });
                thn.pageUnload(() => {
                    debouncedRefresh.cancel();
                    thn.stopObserveDom(containerPrice, refreshPriceMutation);
                });
            }
        },
        bookingObserveDom(ctx) {
            if (!ctx.widget.isSet()) {
                const el = document.getElementsByTagName('body')[0];
                const thnObserveDomFunction = thn.debounce(() => {
                    ctx.widget.logger.debug('*************** DOM Changed **************');
                    if (ctx.widget.setData().isSet()) {
                        ctx.widget.save();
                        thn.stopObserveDom(el, thnObserveDomFunction);
                    }
                }, 600);
                thn.observeDom(el, thnObserveDomFunction);
                thn.pageUnload(() => {
                    thn.stopObserveDom(el, thnObserveDomFunction);
                });
            }
        },
        priceParseData_v1() {
            const nb = window.NB;
            const theme = nb && nb?.theme;
            // On multiroom cases, there is a pair for each room, one visible and one hidden.
            const multiRoomVisibleElements = Array.from(document.querySelectorAll('div[name^="room-item-"]')).filter(el => {
                const visibleItems = thn.isVisible(el);
                return visibleItems;
            });
            const isMultiRoom = multiRoomVisibleElements.length > 1;
            let priceSpecial = window.location.search.match(/roomid/)
                ? SearchPriceSpecial.Generic
                : SearchPriceSpecial.None;
            // Dates
            let dateBegin;
            let dateEnd;
            if (document.getElementById('arrival') && document.getElementById('departure')) {
                dateBegin = document.querySelector('#arrival')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                dateEnd = document.querySelector('#departure')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            }
            else if (document.getElementsByName('arrival').length && document.getElementsByName('departure').length) {
                const dateBeginNoFormat = document.getElementsByName('arrival')?.[0];
                const dateEndNoFormat = document.getElementsByName('departure')?.[0];
                dateBegin = dateBeginNoFormat ? dateBeginNoFormat?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3') : undefined;
                dateEnd = dateEndNoFormat ? dateEndNoFormat?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3') : undefined;
            }
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = ((dateBegin && dateEnd) && thn.daysBetween(dateBegin, dateEnd)) || 0;
            // Rooms
            const dispo = (!thn.isVisible(document.querySelector('#neo-modal-pax-error')) && !thn.isVisible(document.querySelector('.body-background.modal-open')))
                || (window.availability
                    && window.availability.rooms
                    && window.availability.rooms.filter((room) => parseInt(room.availability, 10) || 0).length);
            /**
                  * 2018-12-03: Seems like they updated their BE and we need to changes some
                  * selectors.
                  */
            let babies = 0;
            let prices;
            let roomsDispo = [];
            let adults = 2;
            let children = 0;
            if (theme === 'default' || thn.empty(theme)) {
                // Guests, Adults & Children
                const selectedRoom = Array.from(document.querySelectorAll('[class*="room-item-template"]:not(.done)') || [])
                    .filter((el) => thn.isVisible(el) && !thn.isVisible(el.querySelector('.room-no-selectable')))[0];
                const roomNum = thn.parseNumber(selectedRoom?.querySelector('.name')?.textContent) ?? 1;
                const guestsItems = document.querySelectorAll('#pax-rooms-list>.item.good')[roomNum - 1];
                adults = thn.parseNumber(guestsItems?.querySelector('.adults select')?.value) ?? 2;
                children = thn.parseNumber(guestsItems?.querySelector('.children select')?.value) ?? 0;
                const infants = thn.parseNumber(guestsItems?.querySelector('.babies select')?.value) ?? 0;
                // Children ages
                const childrenAges = [];
                for (let i = 1; i <= children; i += 1) {
                    const age = thn.parseNumber(guestsItems?.querySelector(`.age-select:nth-child(${i}) .age-children`)?.value) || 10;
                    childrenAges.push(age);
                }
                // Infants ages
                for (let i = 1; i <= infants; i += 1) {
                    childrenAges.push(1);
                }
                const roomData = {
                    adults,
                    children: children + infants,
                    childrenAges,
                };
                roomsDispo.push(roomData);
                // Price
                const isUserUsingLoyaltyRates = [1035752].includes(thn.data.accountUserId);
                const shouldUseLoyaltyRates = selectedRoom?.querySelector('.neo-loyalty-price') && isUserUsingLoyaltyRates;
                const priceSelector = shouldUseLoyaltyRates ? '.neo-loyalty-price' : '.amount.neo-price';
                const pricesEls = selectedRoom?.querySelectorAll(priceSelector) || [];
                prices = Array.from(pricesEls).filter((price) => thn.isVisible(price)).map((price) => thn.parseNumber(price?.textContent));
            }
            else if (theme === 'default-v3') {
                // Guests
                const $guestsSelector = $('#available-rooms .room').eq(0);
                if ($guestsSelector.length) {
                    babies = parseInt(($guestsSelector.find('.col5 span.label').eq(0).text()), 10) || 0;
                    adults = parseInt(($guestsSelector.find('.col3 span.label').eq(0).text()), 10) || 2;
                    children = parseInt(($guestsSelector.find('.col4 span.label').eq(0).text()), 10) || 0;
                    children += babies;
                }
                // Price
                prices = [thn.parseNumber($('[title="Final price"]').eq(0).text())];
            }
            // general data handling for all themes
            // rooms dispo
            if (children && roomsDispo && !(theme === 'default' || thn.empty(theme))) {
                const room1Info = {
                    adults,
                    children,
                    childrenAges: [],
                };
                for (let i = 1; i <= children; i += 1) {
                    room1Info.childrenAges.push(i <= (children - babies) ? 10 : 0);
                }
                // add the room info to the "roomsDispo"
                roomsDispo = [room1Info];
            }
            const guests = adults + children;
            const finalPrices = prices?.filter((value) => typeof value !== 'undefined') || [];
            const currency = window.currentCurrencyISOCode || window.defaultCurrencyISOCode || 'EUR';
            const noAvailability = !document.querySelector('#error-rooms-not-found-cont.hidden');
            const usersChangingRoomsOnMultirooms = [1048437];
            if (usersChangingRoomsOnMultirooms.includes(thn.data.accountUserId) && isMultiRoom) {
                priceSpecial = SearchPriceSpecial.Generic;
            }
            if (!thn.empty(finalPrices)) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo,
                    guests,
                    priceSpecial,
                    price: Math.min(...finalPrices) / nights || 1,
                    currency,
                };
            }
            if (!dispo || noAvailability) {
                // No rooms
                return {
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        priceParseData_v2() {
            const dataLayer = (window.dataLayer || []);
            const firstClick = dataLayer
                .filter((event) => event.event === 'gtm.formSubmit').length;
            // first view of the page always shows as no availability, but it's not true
            if (document.querySelector('.MuiLinearProgress-bar') || firstClick < 1) {
                return null;
            }
            // Guests, Adults & Children
            const guestSearch = thn.parseNumber(document.querySelector('span.tw-truncate')?.textContent);
            // Dates;
            const dates = document.querySelectorAll('input.DateInput_input');
            const dateBegin = dates?.[0]?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            const dateEnd = dates?.[1]?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = ((dateBegin && dateEnd) && thn.daysBetween(dateBegin, dateEnd)) || 0;
            // Prices & Currency || No Rooms
            const pricesAndGuests = Array.from(document.querySelectorAll('div[data-component=Proposal]'));
            const pricesArray = pricesAndGuests
                .map((room) => {
                const guests = thn.parseNumber(room.querySelector('[viewBox]')?.parentElement?.nextElementSibling?.textContent);
                const price = thn.parseNumber(room.querySelector(':scope > div:last-child > div > div > div:last-child > div:first-child > div:first-child')?.textContent);
                return { price, guests };
            })
                .filter((room) => room.price && room.guests);
            // we search if there is a room with the same number of guests. If not, we take the cheapest room
            const finalPricesMatchWithGuets = pricesArray.map((room) => room.guests === guestSearch && room.price).filter((value) => typeof value !== 'undefined' && value !== false) || [];
            const finalPrices = finalPricesMatchWithGuets.length ? finalPricesMatchWithGuets : pricesArray.map((room) => room.price).filter((value) => typeof value !== 'undefined') || [];
            // Final price
            const price = finalPrices.length ? Math.min(...finalPrices) : null;
            const guests = finalPricesMatchWithGuets.length ? guestSearch : pricesArray.find((room) => room.price === price)?.guests;
            const currrency = pricesAndGuests ? thn.parseCurrency(pricesAndGuests?.[0]?.querySelector(':scope > div:last-child > div > div > div:last-child > div:first-child > div:first-child')?.textContent) || 'EUR' : 'EUR';
            const noAvailability = document.querySelector('[data-component="Alert"]');
            if (price) {
                return {
                    dateBegin,
                    dateEnd,
                    price: price / nights,
                    adults: guests,
                    children: 0,
                    currency: currrency,
                };
            }
            if (thn.empty(pricesArray) || noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const { NB } = window;
            // Wait until #sb-loading is not visible
            if (thn.isVisible(document.querySelector('#sb-loading'))) {
                return {
                    set: false,
                };
            }
            const bookingId = NB?.reservation_id || document.querySelector('.order-info .title')?.textContent?.split('-')?.[1]?.trim();
            const priceText = document.querySelector('.price')?.textContent ?? '';
            const currency = thn.parseCurrency(priceText) || NB?.reservation_currency || 'EUR';
            const price = thn.parseNumber(document.querySelector('.price')?.textContent) || NB?.reservation_amount;
            const dateBeginHtml = document.querySelector('.datefrom-info')?.textContent || '';
            const dateEndHtml = document.querySelector('.dateto-info')?.textContent || '';
            const dateBegin = NB?.reservation_arrival?.replace(/-/g, '/') || translateDate(dateBeginHtml, thn.data.language);
            const dateEnd = NB?.reservation_departure?.replace(/-/g, '/') || translateDate(dateEndHtml, thn.data.language);
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
            };
        },
    };
};

export { factory };
